import { type TSessionDialogContext, type TSessionDialogVerdict } from '@core/session-dialogs'

export const shouldShowCreatorProfileOffer = ({
    creatorOffer,
}: TSessionDialogContext): TSessionDialogVerdict => {
    if (creatorOffer.isBlocked) {
        return false
    }

    if (creatorOffer.isChecking) {
        return 'pending'
    }

    if (!creatorOffer.isCandidate) {
        return false
    }

    if (!creatorOffer.isAssignmentSettled) {
        return 'pending'
    }

    return true
}
